








































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class MemberBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly footer: any;

  @Prop() readonly gameType!: string;

  @Prop() readonly provider!: string;

  @Prop() readonly currentState!: string;

  @Prop() readonly isFetchNewGameReport!: boolean;

  @Prop() readonly handleSub!: Function;

  utilsInstance = utils;

  displayProvider(item) {
    if (this.currentState === 'amb') return 'amb';
    if (this.currentState === 'provider') {
      if (this.isFetchNewGameReport) {
        return item._id.product === 'ambslot' ? 'askmeslot' : item._id.product;
      }
      return item._id.k;
    }
    if (this.currentState === 'type') return this.provider;
    if (this.item._id) return item.game.toUpperCase();
  }
}
